import { mountBlockedAccountsManager, type BlockControl, type BlockRecoveryHandler } from "../../public/shared/profile/accountBlocks.js";
import type { EpicMobileApi } from "./api";

export function createAccountBlocksDialog(api: EpicMobileApi, options: { onRecover?: BlockRecoveryHandler } = {}) {
  let account = "", actor = "", ready = false, dialog: HTMLDialogElement | null = null;
  let control: BlockControl | null = null, opener: HTMLElement | null = null;
  function close() {
    control?.dispose(); control = null; dialog?.close(); dialog?.remove(); dialog = null;
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  }
  function open() {
    if (!ready || !account) return;
    if (dialog) { dialog.focus(); return; }
    opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    dialog = document.createElement("dialog"); dialog.setAttribute("aria-label", "Blocked accounts");
    dialog.style.cssText = "box-sizing:border-box;width:min(92vw,36rem);max-height:85dvh;overflow:auto;border-radius:16px;padding:20px;border:1px solid #777;";
    const back = document.createElement("button"); back.type = "button"; back.textContent = "Back to account"; back.style.minHeight = "44px";
    back.onclick = close; const content = document.createElement("div"); dialog.append(back, content);
    document.body.append(dialog); dialog.addEventListener("cancel", event => { event.preventDefault(); close(); });
    control = mountBlockedAccountsManager({ root: content, accountUsername: account, request: (path, init) => api.request(path, init), onRecover: reason => { close(); options.onRecover?.(reason); } });
    dialog.showModal(); back.focus();
  }
  return { open, close, refresh() { if (ready) void control?.refresh(); },
    sync(nextAccount: string, nextActor: string, authenticated: boolean) {
      if (nextAccount !== account || nextActor !== actor || !authenticated) close();
      account = nextAccount; actor = nextActor; ready = authenticated;
    }
  };
}
